var MDB = window.MDB || {};

MDB.TrackAndTrace = {
    _Systems: {
        LeadQ: 0,
        BAN: 1,
        P5: 2,
        ARIA: 3
    },
    _States: {
        BAN_P5_IN_PROCES:"BAN_P5_IN_PROCES",
        BAN_P5_MISSING:"BAN_P5_MISSING",
        BAN_P5_UITVAL:"BAN_P5_UITVAL",
        BAN_P5_WACHTRIJ:"BAN_P5_WACHTRIJ",
        BP_UITVAL:"BP_UITVAL",
        LQ_IN_PROGRESS:"LQ_IN_PROGRESS",
        LQ_MISSING:"LQ_MISSING",
        LQ_UITVAL:"LQ_UITVAL",
        OK_VERWERKT:"OK_VERWERKT",
        SCHORSING:"SCHORSING",
        SPIJTOPTANT:"SPIJTOPTANT",
        STRAATVERKOOP_TM_OPVOLGING:"STRAATVERKOOP_TM_OPVOLGING",
        STRAATVERKOOP_TM_UITVAL: "STRAATVERKOOP_TM_UITVAL",
        NIETVERWERKT: "NIETVERWERKT"
    },
    boot: function (config) {
        MDB.TrackAndTrace.initKendoGrid(config);
        MDB.TrackAndTrace.initCustomControls(config.banMissing.getDeclineReasonsUrl, config.base.editUrl);
    },
    initKendoGrid: function (config) {
        var crudServiceBaseUrl = '/api/DPN/TrackAndTrace/';
        
        var grid = $('#grid'),
            searchForm = $('#search-form');     

        var dataSource = new kendo.data.DataSource({
            transport: {
                read: function (opts) {
                    var url;
                    if (MDB.TrackAndTrace._export_busy) {
                        url = crudServiceBaseUrl + 'Get' + '?' + searchForm.serialize();
                        url += '&ExportData=true';
                        MDB.TrackAndTrace._export_busy = false;
                        document.location = url;
                    } else {
                        url = crudServiceBaseUrl + 'Get' + '?' + searchForm.serialize();
                        MDB.KendoConfigBuilder.dataSourceTransportFunction(url, 'GET', opts);
                    }
                },
                destroy: $.noop
            },
            batch: false,
            pageSize: 20,
            schema: {
                model: {
                    id: 'LeadId',
                    fields: {
                        LeadId: { editable: false },
                        RefId: {nullable: true, editable: false},
                        Address: { nullable: true, editable: false },
                        Contact: { nullable: true, editable: false },
                        Subscription: { nullable: true, editable: false },
                        RecruitmentData: { nullable: true, editable: false },
                        State: { nullable: true, editable: false },
                        Processed: { nullable: true, editable: false }
                    }
                }
            },
            error: function (e) {
                this.cancelChanges();
                MDB.Notify.errorGrowl(MDB.KendoConfigBuilder.getWebApiErrorsMessage(e));
            }
        });

        var createHtmlFieldRenderer = function (field) {
            return function (model) {
                //Replace <br />s with newlines -> HTML encode value -> replace newlines with <br />s
                return kendo.htmlEncode(model[field].replace(/\<br\s*\/?\>/gi, '\n')).replace(/\n/g, '<br />');
            };
        };

        var gridConfig = {
            toolbar: ['excel'],
            excel: {
                fileName: 'Track&Trace search results ' + moment().format('DD-MM-YYYY HH:mm:ss') + '.xlsx',
                allPages: true
            },
            autoBind: false,
            dataBound: function() {
                var grid = this;
                this.tbody.find('tr').each(function() {
                    var me = $(this);
                    var item = grid.dataItem(me);

                    if (item.State !== MDB.TrackAndTrace._States.BAN_P5_MISSING &&
                        item.State !== MDB.TrackAndTrace._States.BAN_P5_UITVAL &&
                        item.State !== MDB.TrackAndTrace._States.BP_UITVAL &&
                        item.State !== MDB.TrackAndTrace._States.LQ_UITVAL &&
                        item.State !== MDB.TrackAndTrace._States.STRAATVERKOOP_TM_UITVAL) {
                        //me.find('.k-grid-edit-custom').hide();
                    }
                });
            },

            dataSource: dataSource,
            pageable: MDB.KendoConfigBuilder.gridPageableSettings(),
            columns: [
                {
                    field: 'LeadId',
                    title: MDB.loadResourceString('DPN_TrackAndTrace_Index_SearchTable_LeadId_Displayname'),
                    hidden: true
                },
                {
                    field: 'RefId',
                    title: MDB.loadResourceString('DPN_TrackAndTrace_Index_SearchTable_RefId_Displayname'),
                    hidden: true
                },
                {
                    field: 'Address',
                    title: MDB.loadResourceString('DPN_TrackAndTrace_Index_SearchTable_Address_Displayname'),
                    template: createHtmlFieldRenderer('Address')
                },
                {
                    field: 'Contact',
                    title: MDB.loadResourceString('DPN_TrackAndTrace_Index_SearchTable_Contact_Displayname'),
                    template: createHtmlFieldRenderer('Contact')
                },
                {
                    field: 'Subscription',
                    title: MDB.loadResourceString('DPN_TrackAndTrace_Index_SearchTable_Subscription_Displayname'),
                    template: createHtmlFieldRenderer('Subscription')
                },
                {
                    field: 'RecruitmentData',
                    title: MDB.loadResourceString('DPN_TrackAndTrace_Index_SearchTable_RecruitmentData_Displayname'),
                    template: createHtmlFieldRenderer('RecruitmentData')
                },
                {
                    field: 'State',
                    title: MDB.loadResourceString('DPN_TrackAndTrace_Index_SearchTable_Status_Displayname'),
                    template: createHtmlFieldRenderer('State')
                },
                {
                    field: 'Processed',
                    title: MDB.loadResourceString('DPN_TrackAndTraceSearchModel_RecordSuccessfullyProcessed_DisplayName'),
                    template: createHtmlFieldRenderer('Processed')
                }
            ],
            messages: {
                commands: MDB.KendoConfigBuilder.commandLabels(),
                noRecords: MDB.loadResourceString('DataTable_ZeroRecords')
            },
            navigatable: true,
            sortable: { mode: 'multiple' },
            scrollable: false,
            filterable: {
                cell: {
                    enabled: false
                }
            }
        };

        gridConfig.editable = {
            update: true,
            destroy: false
        };

        gridConfig.columns.push(
            MDB.KendoConfigBuilder.gridCommandColumn([
                {
                    name: 'edit-custom',
                    text: MDB.loadResourceString('Button_Edit'),
                    imageClass: 'k-icon k-edit',
                    click: function (e) {
                        e.preventDefault();
                        e.stopPropagation();

                        var dataRow = ($(e.currentTarget).closest('tr'));
                        var dataItem = this.dataItem(dataRow);

                        var partial = '/DPN/TrackAndTrace/GetEditor' + '?state=' +
                            encodeURIComponent(dataItem.State) + '&system=' +
                            encodeURIComponent(dataItem.System) + '&refId=' +
                            encodeURIComponent(dataItem.RefId) + '&leadId=' +
                            encodeURIComponent(dataItem.LeadId);
                        
                        $.ajax({
                            url: partial,
                            error: function(request, status, error){
                                MDB.Notify.bootstrapDanger(MDB.loadResourceString('Generic_Error_Text'));
                                endSession(dataItem.LeadId);
                            }
                        }).done(function(response){
                            //Response can be either JSON or HTML
                            //In case of JSON it most likely implies an error :-)
                            if(response.errors && response.errors.length){
                                MDB.alert(response.errors.join('\n'));
                                return;
                            }

                            var editContainer = $("#edit-container");
                            var modal = $("#editModal");

                            editContainer.html(response);

                            if (dataItem.State === MDB.TrackAndTrace._States.BAN_P5_MISSING && dataItem.System === MDB.TrackAndTrace._Systems.BAN) {
                                MDB.TrackAndTrace.initBanMissing(config.banMissing, dataItem.System, dataItem.LeadId, config.base.editUrl);
                            } else if (dataItem.State === MDB.TrackAndTrace._States.BAN_P5_MISSING && dataItem.System === MDB.TrackAndTrace._Systems.P5 ||
                                    dataItem.State === MDB.TrackAndTrace._States.BAN_P5_UITVAL ||
                                    dataItem.State === MDB.TrackAndTrace._States.BP_UITVAL ||
                                    dataItem.State === MDB.TrackAndTrace._States.LQ_UITVAL
                            ) {
                                MDB.TrackAndTrace.initProcessedControls(dataItem.LeadId, dataItem.RefId,
                                    config.banMissing.getDataUrl, config.banMissing.getDeclineReasonsUrl);
                            } else if(dataItem.State === MDB.TrackAndTrace._States.LQ_UITVAL) {
                                MDB.TrackAndTrace.initLeadQMissingControls();
                            }
                                
                            var leadChanged = modal.find('[name$="LeadChanged"]');

                            if(leadChanged.length > 0) {
                                modal.find('#lead-editor').find('input,select').change(function () {
                                    leadChanged.val('True');
                                });
                            }

                            MDB.initKendoDatePickers();
                            modal.modal('show');
                                
                            modal.one('hide.bs.modal', function(){
                                endSession(dataItem.LeadId);
                            });
                        });
                    }
                }
            ])
        );
        grid.kendoGrid(gridConfig);

        function endSession(leadId) {
            //End our session silently
            $.ajax('/DPN/TrackAndTrace/EndSession?leadId=' + leadId);
        }
    },
    initCustomControls: function (declineReasonsUrl, editUrl) {
        var kendoGrid = MDB.KendoConfigBuilder.getKendoWidget($('.k-grid'));
        var startDate = $('#startDate');
        var endDate = $('#endDate');
        var declineReasonColumns = $('.decline-reason-column');
        var declineDropdown = $('#FilterDeclineReasonId');

        $('a.k-grid-excel').on('click', function(e) {
            MDB.TrackAndTrace._export_busy = true;
        });

        $('#searchButton').click(function (e) {
            MDB.TrackAndTrace._export_busy = false;
            e.preventDefault();
            kendoGrid.dataSource.read();
        });

        $('#Site').kendoDropDownList({ filter: "contains" });

        $('#State').change(function(e) {
            var me = $(this);
            var declineReasonStates = [
                "BAN_P5_UITVAL",
                "BP_UITVAL",
                "LQ_UITVAL",
                "SCHORSING"
            ];
            if (declineReasonStates.includes(me.val())) {
                MDB.TrackAndTrace.getDeclineReasons(declineReasonsUrl, null, me.val(), true);
                declineReasonColumns.each(function() {
                    $(this).show();
                });
            } else {
                declineReasonColumns.each(function() {
                    $(this).hide();
                });
                declineDropdown.val("");
            }
        });

        startDate.kendoDatePicker({
            dateInput: true,
            format: 'dd-MM-yyyy',
            parseFormats: ["dd MM yyyy"]
        });

        endDate.kendoDatePicker({
            dateInput: true,
            format: 'dd-MM-yyyy',
            parseFormats: ["dd MM yyyy"]
        });

        $('#save-record').click(function (e) {
            e.preventDefault();
            save();
        });

        $('#resend-record').click(function (e) {
            e.preventDefault();
            
            //Selector should match both Lead_ResendToSubscriptionService and ResendToSubscriptionService
            $('[name$="ResendToSubscriptionService"]').val('True');
            save();
        });

        function save(data) {
            $.ajax({
                type: "POST",
                url: editUrl + '?' + $('#edit-form').serialize(),
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: function (data) {

                    if (data.errors.length > 0) {
                        MDB.Notify.errorGrowl(data.errors.join(', '));
                    } else {
                        kendoGrid.dataSource.read();
                        MDB.Notify.successGrowl("Record successfully updated.");
                    }

                    //Hiding also automagically ends our session our session
                    $("#editModal").modal('hide');
                },
                error: function () {
                    MDB.Notify.errorGrowl('Oops! Something went wrong.');
                }
            });
        }
    },
    getDeclineReasons: function (getDeclineReasonsUrl, flowstate, state, isSearch) {

        state = isSearch ? state : MDB.TrackAndTrace._States.NIETVERWERKT;

        $.ajax({
            type: "GET",
            url: getDeclineReasonsUrl,
            contentType: "application/json; charset=utf-8",
            data: { 
                flowState: flowstate,
                state: state 
            },
            dataType: "json",
            success: function (data) {
                if (data.errors.length !== 0) {
                    MDB.Notify.errorGrowl(data.errors.join(', '));
                }

                var declineReasonIdDropdown = isSearch ? $('#FilterDeclineReasonId') : $('#DeclineReasonId');
                declineReasonIdDropdown.empty();
                declineReasonIdDropdown.append('<option value="">' +
                    MDB.loadResourceString('DPN_TrackAndTrace_Index_EditModal_Select_DeclineReason_Text') +
                    '</option>');

                data.declineReasons.forEach(function (reason) {
                    declineReasonIdDropdown.append('<option value="' + reason.Value+ '">' + reason.Text + '</option>');
                });
            },
            error: function () {
                MDB.Notify.errorGrowl('Oops! Something went wrong.');
            }
        });
    },
    getBanMissingEditStates: function (getStatesUrl, system) {
        system = system === undefined ? null : system;

        $.ajax({
            type: "GET",
            url: getStatesUrl,
            contentType: "application/json; charset=utf-8",
            data: {
                system: system
            },
            dataType: "json",
            success: function (data) {
                if (data.errors.length !== 0) {
                    MDB.Notify.errorGrowl(data.errors.join(', '));
                }

                var flowStateDropdown = $('#FlowitemStateId');
                flowStateDropdown.empty();
                flowStateDropdown.append('<option value="">' +
                    MDB.loadResourceString('DPN_TrackAndTrace_Index_EditModal_Select_FlowState_Text') +
                    '</option>');

                data.states.forEach(function (state) {
                    flowStateDropdown.append('<option value="' + state.value + '">' + '(' + state.value + ') ' + state.text + '</option>');
                });

                MDB.TrackAndTrace.initBanMissingControls(flowStateDropdown);
            },
            error: function () {
                MDB.Notify.errorGrowl('Oops! Something went wrong.');
            }
        });
    },
    getBanP5Data: function (getDataUrl, leadId) {
        var table = $('#get-ban-p5-data-table');

        //Clear table on second click
        if (table.children().length) {
            table.empty();
            return;
        }

        table.data('getBanP5Data') || $.ajax({
            type: "GET",
            url: getDataUrl,
            contentType: "application/json; charset=utf-8",
            data: {
                leadId: leadId
            },
            dataType: "json" 
        }).done(function(data) {
            if (data.errors.length !== 0) {
                MDB.Notify.errorGrowl(data.errors.join(', '));
            } else {
                MDB.TrackAndTrace.buildBanP5DataTable(table, data.rows);
            }
        }).error(function () {
            MDB.Notify.errorGrowl('Oops! Something went wrong.');
        });
    },
    buildBanP5DataTable: function (table, rows) {
        rows.forEach(function (row) {
            Object.keys(row).forEach(function (key) {
                var tableRow = $('<tr />')
                    .append($('<td />').text(key + ':'))
                    .append($('<td />', {class: 'pl-3'}).text(row[key]));

                table.append(tableRow);
            });
        });
    },
    attachBanP5DataClickHandler: function (leadId, url) {
        $('#get-ban-p5-data').click(function (e) {
            e.preventDefault();
            MDB.TrackAndTrace.getBanP5Data(url, leadId);
        });  
    },
    initBanMissing: function (config, system, leadId) {
        var flowStateDropdown = $('#FlowitemStateId');
        $('#LeadId').val(leadId);

        MDB.TrackAndTrace.getBanMissingEditStates(config.getStatesUrl, system);
        MDB.TrackAndTrace.initDatepicker('#contractStartDate');

        flowStateDropdown.change(function () {
            MDB.TrackAndTrace.getDeclineReasons(config.getDeclineReasonsUrl, flowStateDropdown.val(), null, false);
            MDB.TrackAndTrace.initBanMissingControls(flowStateDropdown);
        });

        MDB.TrackAndTrace.attachBanP5DataClickHandler(leadId, config.getDataUrl);
    },
    initDatepicker: function(selector){
        $(selector).kendoDatePicker({
            dateInput: true,
            value: new Date(),
            format: 'dd-MM-yyyy',
            parseFormats: ["dd MM yyyy"]
        });
    },
    initBanMissingControls: function (flowStateDropdown) {
        if (flowStateDropdown.val() === '300' || flowStateDropdown.val() === "304") {
            $('#declineRow').hide();
            $('#contractRow').show();
            $('#contractStartRow').show();
        } else {
            $('#declineRow').show();
            $('#ContractId').val("");
            $('#contractStartDate').val("");
            $('#contractRow').hide();
            $('#contractStartRow').hide();
        }
    },
    initProcessedControls: function (leadId, refId, getDataUrl, getDeclineReasonsUrl) {
        $('#LeadId').val(leadId);
        $('#RefId').text(refId);

        var processed = $('#RecordProcessed');
        var notProcessed = $('#RecordNotProcessed');

        var processedRow = $('#processedRow');

        MDB.TrackAndTrace.initDatepicker('#contractStartDate');
        MDB.TrackAndTrace.getDeclineReasons(getDeclineReasonsUrl, null, MDB.TrackAndTrace._States.NIETVERWERKT, false);

        processed.click(function(e) {
            if (this.checked === notProcessed[0].checked) {
                notProcessed.click();
            }
            
            if(this.checked){
                processedRow.find('input').attr('disabled', null);
                processedRow.show();
            } else{
                processedRow.find('input').attr('disabled', 'disabled');
                processedRow.hide();
            }
        });
        notProcessed.click(function (e) {
            if (this.checked === processed[0].checked) {
                processed.click();
            }
            if (this.checked) {
                $('#declineRow').show();
            } else {
                $('#declineRow').hide();
            }
        });

        MDB.TrackAndTrace.attachBanP5DataClickHandler(leadId, getDataUrl);
    },
    initLeadQMissingControls: function() {
        var birthDate = $('#BirthDateValue');
        birthDate.kendoDatePicker({
            dateInput: true,
            format: 'dd-MM-yyyy',
            parseFormats: ["dd MM yyyy"]
        });
    }
};